import { Redirect, Route, type RouteProps } from "react-router";

export type GuardedRouteProps = {
  isAuthenticated: boolean;
  isAccepted: boolean;
  authenticationPath: string;
  agreementPath: string;
} & RouteProps;

export default function GuardedRoute({
  isAuthenticated,
  isAccepted,
  authenticationPath,
  agreementPath,
  ...routeProps
}: GuardedRouteProps) {
  if (!isAuthenticated) {
    return <Redirect to={{ pathname: authenticationPath }} />;
  }
  if (!isAccepted) {
    return <Redirect to={{ pathname: agreementPath }} />;
  }
  return <Route {...routeProps} />;
}
